// Copyright 2020
//   __  __                       _           _     _   _            _ _   _     
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__  
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \ 
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//                                                                              
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/load/v1/load.proto (package msh.trait.load.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message msh.trait.load.v1.LoadTrait
 */
export const LoadTrait = proto3.makeMessageType(
  "msh.trait.load.v1.LoadTrait",
  [],
);

/**
 * @generated from message msh.trait.load.v1.LoadTrait.Load
 */
export const LoadTrait_Load = proto3.makeMessageType(
  "msh.trait.load.v1.LoadTrait.Load",
  () => [
    { no: 1, name: "load_1m", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "load_5m", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "load_15m", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "LoadTrait_Load"},
);

/**
 * ----------- Commands ----------- //
 *
 * @generated from message msh.trait.load.v1.LoadTrait.Command
 */
export const LoadTrait_Command = proto3.makeMessageType(
  "msh.trait.load.v1.LoadTrait.Command",
  [],
  {localName: "LoadTrait_Command"},
);

/**
 * ----------- EVENTS ----------- //
 *
 * @generated from message msh.trait.load.v1.LoadTrait.LoadEvent
 */
export const LoadTrait_LoadEvent = proto3.makeMessageType(
  "msh.trait.load.v1.LoadTrait.LoadEvent",
  () => [
    { no: 2, name: "load", kind: "message", T: LoadTrait_Load },
  ],
  {localName: "LoadTrait_LoadEvent"},
);

